import * as React from 'react';

import { Thing, WithContext } from 'schema-dts';

import { serializeJsonLd } from './serialize';

interface IJsonLdProps<T extends Thing> {
  item: WithContext<T>;
}

/**
 * Drop-in replacement for `react-schemaorg`'s `JsonLd`, which HTML-escapes every
 * string value (`&` -> `&amp;`, `"` -> `&quot;`) inside the JSON. That is invalid
 * for JSON-LD and leaks entities into structured data consumed by crawlers.
 */
export const JsonLd = <T extends Thing>({ item }: IJsonLdProps<T>) => (
  <script
    type="application/ld+json"
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: serializeJsonLd(item) }}
  />
);
